let csrfToken: string | null = null

export function setServerCsrfToken(value: string | null): void {
  csrfToken = value
}

export function serverMutationHeaders(): Record<string, string> {
  return csrfToken ? { 'X-Arena-CSRF': csrfToken } : {}
}
